<template>
    <div class="row">
        <div class="text-left col-sm">
            <img src="@/assets/logo-h-white.png" class="pl-2" style="width:200px; heigth:100px;">
        </div>
        <div class="col-sm pt-3">
            <router-link :to="{ name: button.path }" v-for="(button, index) in buttons" v-bind:key="index" class="d-inline btn-sm text-center text-uppercase">
                {{ button.name }}
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "MainNavMenu",
    props:{
        buttons: {
            type: Array,
            required: true
        },
    }
}
</script>

<style scoped>
a {
  color: white;
}
a.hover {
    color: white;
}
</style>